// Slider : synchronise l’affichage de la valeur
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-slider]').forEach(s => {
        const range = s.querySelector('input[type="range"]');
        const out = s.querySelector('.slider__value');
        if (!range) return;
        const sync = () => { if (out) out.textContent = range.value; };
        range.addEventListener('input', sync);
        sync();
    });
});
